import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

import ContentfulLongText from '../../ContentfulLongText'

import './content-two-column.css'

export const ContentTwoColumn = ({ pageData }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return pageData !== null ? pageData.map((item, index) => (
        <div key={index} className='content-two-column' style={{ backgroundColor: item.backgroundColor }}>
            <div className='container-med'>
                <div ref={ref} className={`grid justify-center col-1-md${item.image !== null ? ' align-center col-2 gap-10 two':'col-1 one'} ${item.contentColor.toLowerCase()}`}>
                    <div className='content' style={{ 
                    transform: isInView ? "none" : "translateX(-200px)", 
                    opacity: isInView ? 1 : 0, 
                    transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"}}>
                        {item.titleVisibility && <motion.h2 className="mt-0 mb-0" style={{ 
                            transform: isInView ? "none" : "translateX(-200px)", 
                            opacity: isInView ? 1 : 0, 
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"}}>{item.title} <span>{item.titleNotes}</span></motion.h2>}
                        <img className='mb-0' src={item.contentMedia} alt={item.title || 'Two Column Media'} style={{ 
                            transform: isInView ? "none" : "translateX(2000px)", 
                            opacity: isInView ? 1 : 0, 
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"}}/>
                        {item.content !== null && <ContentfulLongText longTextContent={item.content.content} />}
                        {item.intro !== null && <ContentfulLongText longTextContent={item.intro.intro} />}
                        {item.contentLists !== null && item.contentLists.map((listItem, j) => (
                            <div key={j} className='mb-0 item'>
                                <p className='mb-0' style={{ fontWeight: 700, color: listItem.titleColor }}>{`${j+1}) `}{listItem.title}</p>
                                <ContentfulLongText longTextContent={listItem.content.content}/>
                            </div>
                        ))}
                    </div>
                    {item.image !== null && <div className='image' style={{ 
                    transform: isInView ? "none" : "translateX(2000px)", 
                    opacity: isInView ? 1 : 0, 
                    transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"}}><img src={item.image.gatsbyImageData.images.fallback.src} alt={item.title || 'Two Column Media'}/></div>}
                </div>
            </div>
        </div>
    )):null
}